// MODEL : instance of Column

define('app/editor/SegmentView',['require','glu/itemView','app/filters/CompactFieldFilterView','hbs!./SegmentView.hbs'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView'),
		CompactFieldFilterView = require('app/filters/CompactFieldFilterView');

	return ItemView.extend({

		template: require('hbs!./SegmentView.hbs'),

		tagName: 'li',
		className: 'monitor segment',

		events: {
			'click .delete button': 'remove',
			'click .show-filters': 'toggleSegment',
			'click .hide-filters': 'toggleSegment'
		},

		initialize: function() {},

		onRender: function() {
			this.addFilters();

			// Hide filter list by default
			this.$el.find('> ul').hide();
		},

		serializeData: function() {
			return this;
		},

		getName: function() {
			return this.model.getName();
		},

		getDescription: function() {
			return this.model.getDescription();
		},

		metricId: function() {
			return this.model.getId();
		},

		remove: function(e) {
			e.preventDefault();
			e.stopPropagation();

			var index = this.options.monitor.getSegments().indexOf(this.model.getId());
			if (index > -1) {
				this.options.monitor.getSegments().splice(index, 1);
			}
			this.options.monitor.trigger('monitor:change');
			this.appBus.trigger('monitor:refresh');
		},

		index: function() {
			return this.options.segments.indexOf(this.model);
		},

		toggleSegment: function(e) {
			if (e) {
				e.preventDefault();
			}

			this.$el.find('> ul').toggle();
			this.$el.find('.show-filters').toggleClass('hidden');
			this.$el.find('.hide-filters').toggleClass('hidden');
			this.appBus.trigger('monitor:viewport:change');
		},

		addFilters: function() {
			var self = this,
				filtersList = this.$el.find('.segment-compound-filters-list'),
				domain = self.options.monitor.getDomain(),
				segmentFilter = domain.buildFilter(this.model.get('filters'));

			segmentFilter.filterCollection().each(function(filter) {
				filter.set('segmentId', self.model.get('id'));
				var view = new CompactFieldFilterView({
					model: filter,
					report: self.options.monitor,
					tagName: 'li',
					className: 'form-group filter-compact'
				});

				view.render();
				filtersList.append(view.render().$el);
			});
		}
	});
});

